import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import leadBanner from "../../assets/images/lead-management/lead-mngment-banner.png";
import leadCapture from "../../assets/images/lead-management/lead-capture.png";
import onlineChannels from "../../assets/images/lead-management/online-channels.png";
import streamLineSalesPipeline from "../../assets/images/lead-management/streamline-sales-pipeline.png";
import maximiseLeadGen from "../../assets/images/lead-management/maximise-lead-gen.png";
import integratedLeadCapture from "../../assets/images/homePage/integrated_lead_capture.png";
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";

const BannerSection = () => {
  return (
    <>
      <div className="lead-managment-wrapper">
        <section className="leadMngmnetBanner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  From First Click to Loyal Customer
                </h1>
                <p className="heading16px roboto-regular mb30 text-color-131415">
                  {" "}
                  Unlock your growth potential by managing <br /> leads
                  effortlessly from start to finish.
                </p>

                <ul className="btn-sec mb20">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Get Started
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>

                <img
                  src={leadBanner}
                  loading="lazy"
                  class="img-responsive position-relative"
                  alt="From First Click to Loyal Customer"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="company-search-etc">
                  <h3 className="heading20px roboto-bold mb10">Lead Capture</h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz makes it easy for businesses to connect with
                    potential customers by capturing vital information right at
                    the source. With direct lead capture, you can seamlessly
                    gather important details like names, emails, phone numbers,
                    and company info—all in real time. No more missed
                    opportunities, just instant access to the leads that matter,
                    so you can engage the right people at the right moment.
                  </p>

                  <ul class="points-ul mt30">
                    <li class="heading16px roboto-regular">
                      <strong>Effortless lead collection</strong> <br />{" "}
                      Instantly capture valuable customer details from various
                      sources.
                    </li>
                    <li class="heading16px roboto-regular">
                      <strong>Timely engagement</strong> <br /> Get the info you
                      need to start building relationships immediately.
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={leadCapture}
                    alt="Lead Capture"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={onlineChannels}
                    alt="Online Channels"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div className="company-search-etc">
                  <h3 className="heading20px roboto-bold mb10">
                    Online Channels
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz lead alerts notify your sales and marketing
                    teams instantly when new leads are captured, enabling fast
                    follow-ups for higher conversions. Ideal for businesses with
                    high lead volumes, these alerts can be sent via email, SMS,
                    WhatsApp, or other channels. They include key details like
                    the lead’s name, email, and phone number, ensuring quick and
                    effective responses.
                  </p>

                  <ul class="points-ul mt30">
                    <li class="heading16px roboto-regular">
                      <strong>Instant notifications</strong> <br /> Stay ahead
                      by responding to leads as soon as they come in.
                    </li>
                    <li class="heading16px roboto-regular">
                      <strong>Multi-channel delivery</strong> <br /> Receive
                      alerts through the channels most convenient for your team.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center max-width950">
                <div className="company-search-etc">
                  <h3 className="heading20px roboto-bold mb10">
                    Streamline your sales pipeline
                  </h3>
                  <p className="heading16px roboto-regular">
                    Easily visualize every stage of your sales process to ensure
                    nothing slips through the cracks. Prioritize key
                    opportunities and stay organized by moving leads through
                    each phase, closing deals faster and improving efficiency.
                    Kanban makes lead management simple and effective, driving
                    better results.
                  </p>

                  <ul class="points-ul mt30">
                    <li class="heading16px roboto-regular">
                      <strong>Clear Insights</strong> <br /> Easily identify and
                      prioritize high-potential leads.
                    </li>
                    <li class="heading16px roboto-regular">
                      <strong>Efficient Workflow</strong> <br /> Seamlessly
                      manage leads and close deals faster.
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={streamLineSalesPipeline}
                    alt="Streamline your sales pipeline"
                    className="img-responsive"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="_border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold heading29px mb40 text-center">
                Capture All Your Hotel & Resort Booking Inquiries, <br /> No
                Matter Where They Come From.
              </h2>
              <div className="grid-auto-fit align-items-center max-width950 ">
                <div>
                  <img
                    src={integratedLeadCapture}
                    alt="Maximize Your Lead Generation with BeyondLeadz’s Accurate B2B Data"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div className="company-search-etc">
                  <p className="poppins-regular heading16px mb10">
                    Capture leads directly from popular booking sites like
                    MakeMyTrip, TripAdvisor, Hotels.com, and Booking.com.
                  </p>
                  <p className="poppins-regular heading16px">
                    BeyondLeadz automatically integrates these leads into your
                    marketing database, enabling you to follow up with
                    personalized offers and promotions.
                  </p>
                  <NavLink
                    to={"/signup"}
                    className="common-btn-class main-btn-primary poppins-regular mt30"
                  >
                    Try Now
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="_border-top">
                    <div className="max-container">
                        <div className="padd-90">
                            <h2 className="roboto-bold heading29px mb40 text-center">Maximize Your Lead Generation with <br /> BeyondLeadz’s Accurate B2B Data</h2>
                            <div className="grid-auto-fit align-items-center max-width950 ">
                                <div><img src={maximiseLeadGen} alt="Maximize Your Lead Generation with BeyondLeadz’s Accurate B2B Data" className="img-responsive" loading="lazy" /></div>
                                <div className="company-search-etc">
                                    <p className="heading16px roboto-regular">BeyondLeadz simplifies lead generation by providing precise B2B data and customizable filters like company size, industry, and revenue. Users can automatically import leads based on criteria such as job title, helping businesses focus on high-potential prospects for better sales results.</p>
                                    <ul class="points-ul mt30">
                                        <li class="heading16px roboto-regular"><strong>Direct Lead Capture</strong> <br /> Access accurate B2B data to quickly identify key decision-makers and their contact details.</li>
                                        <li class="heading16px roboto-regular"><strong>Real-Time Lead Alerts</strong> <br /> Stay updated on new opportunities with instant lead notifications.</li>
                                        <li class="heading16px roboto-regular"><strong>Automated Lead Import</strong> <br /> Automatically import leads based on criteria like industry or job title for efficient targeting.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};
export default BannerSection;
